import { get } from "../ApiService";

const withParams = (url, params = {}) => get(url, params);

export const analyticsSection1 = async (params = {}) => {
    return withParams('/dashboard/get-analytics/section-1/', params);
};

export const analyticsSection2 = async (params = {}) => {
    return withParams('/dashboard/get-analytics/section-2/', params);
};

export const analyticsUserByDevice = async (params = {}) => {
    return withParams('/dashboard/get-analytics/users-by-device/', params);
};

export const analyticsTopProjects = async (params = {}) => {
    return withParams('/dashboard/get-analytics/top-projects/', params);
};

export const analyticsTopSupplier = async (params = {}) => {
    return withParams('/dashboard/get-analytics/top-suppliers/', params);
};

export const analyticsMonthlyTrend = async (params = {}) => {
    return withParams('/dashboard/get-trend/monthly/', params);
};

export const analyticsDailyTrend = async (params = {}) => {
    return withParams('/dashboard/get-trend/daily/', params);
};

export const analyticsRdMonthlyTrend = async (params = {}) => {
    return withParams('/dashboard/get-trend/monthly/rd-failures/', params);
};

export const analyticsRdDailyTrend = async (params = {}) => {
    return withParams('/dashboard/get-trend/daily/rd-failures/', params);
};
